import React from 'react';
import { Collapse } from '@mui/material';

import HideButton from '../../../components/hide-button/HideButton';

import scss from './FormSection.module.scss';

function FormSection({ isShowForm, onChangeVisibility, hideLabel, children }) {
  return (
    <div className={scss.formSection}>
      <HideButton isShow={isShowForm} onToggleVisibility={onChangeVisibility} label={hideLabel} />

      <Collapse in={isShowForm}>
        <div className={scss.formWrapper}>{children}</div>
      </Collapse>
    </div>
  );
}

export default FormSection;
